import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Button } from "../components/common/Button";

const NotFoundContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
  padding: 40px 20px;
`;

const StatusCode = styled.h1`
  font-size: 120px;
  font-weight: bold;
  margin: 0;
  line-height: 1;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 32px;
`;

const NotFoundIcon = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      fill="currentColor"
    />
  </svg>
);

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <NotFoundContainer>
      <StatusCode>404</StatusCode>
      <NotFoundIcon />
      <Title>PAGINA NON TROVATA</Title>
      <Description>
        LA PAGINA CHE STAI CERCANDO NON ESISTE O È STATA SPOSTATA.
      </Description>
      <Button fullWidth onClick={() => navigate("/")}>
        TORNA ALLA HOME
      </Button>
    </NotFoundContainer>
  );
};
